import { render, staticRenderFns } from "./StockRcompany.vue?vue&type=template&id=c955c268&scoped=true&"
import script from "./StockRcompany.vue?vue&type=script&lang=js&"
export * from "./StockRcompany.vue?vue&type=script&lang=js&"
import style0 from "./StockRcompany.vue?vue&type=style&index=0&id=c955c268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c955c268",
  null
  
)

export default component.exports